import React from "react";
import PropTypes from "prop-types";
import {
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from "reactstrap";

/**
 * 設定式下拉選單（design system primitive）。
 * items 支援：一般項、divider、header、disabled、danger、icon。
 *
 *   <Dropdown label="操作" icon="mdi-cog" items={[
 *     { label:"編輯", icon:"mdi-pencil", onClick:onEdit },
 *     { divider:true },
 *     { label:"刪除", icon:"mdi-delete", danger:true, onClick:onDelete },
 *   ]} />
 */
const renderItems = (items) =>
  items.map((it, i) => {
    if (it.divider) return <DropdownItem divider key={`d${i}`} />;
    if (it.header) return <DropdownItem header key={`h${i}`}>{it.header}</DropdownItem>;
    return (
      <DropdownItem
        key={it.key || it.label || i}
        onClick={it.onClick}
        disabled={it.disabled}
        className={it.danger ? "text-danger" : undefined}
      >
        {it.icon ? <i className={`mdi ${it.icon} me-2`} /> : null}
        {it.label}
      </DropdownItem>
    );
  });

export const Dropdown = ({
  label,
  icon,
  items = [],
  variant = "light",
  size,
  caret = true,
  end = false,
}) => (
  <UncontrolledDropdown>
    <DropdownToggle
      color={variant.replace("outline-", "")}
      outline={variant.startsWith("outline-")}
      size={size}
      caret={caret}
    >
      {icon ? <i className={`mdi ${icon} me-1`} /> : null}
      {label}
    </DropdownToggle>
    {/* 掛到 body:選單常常開在有捲軸/overflow 的容器裡(表格、卡片),
        留在原地會被裁掉半截 */}
    <DropdownMenu end={end} container="body">{renderItems(items)}</DropdownMenu>
  </UncontrolledDropdown>
);
Dropdown.propTypes = {
  label: PropTypes.node,
  icon: PropTypes.string,
  items: PropTypes.array.isRequired,
  variant: PropTypes.string,
  size: PropTypes.oneOf(["sm", "lg"]),
  caret: PropTypes.bool,
  end: PropTypes.bool,
};

/**
 * 列表列的「更多」動作選單（kebab），DataTable actions 常用。
 *   <RowActions items={[{label:"編輯",icon:"mdi-pencil",onClick},{label:"刪除",danger:true,onClick}]} />
 */
export const RowActions = ({ items, size = "sm", label = "操作" }) => (
  <UncontrolledDropdown>
    {/* 只有 icon 的按鈕要有名字,讀螢幕的人才知道這顆是什麼 */}
    <DropdownToggle color="light" size={size} className="btn-icon" aria-label={label}>
      <i className="mdi mdi-dots-horizontal" />
    </DropdownToggle>
    {/* 同上:列動作選單一定在表格裡,不掛到 body 就會被表格的捲動容器裁掉 */}
    <DropdownMenu end container="body">{renderItems(items)}</DropdownMenu>
  </UncontrolledDropdown>
);
RowActions.propTypes = {
  items: PropTypes.array.isRequired,
  size: PropTypes.oneOf(["sm", "lg"]),
  label: PropTypes.string,
};

export default Dropdown;
